export default {"src":"/_next/static/media/star_gold.31a1082a.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};